// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BgnOP","right":"styles_right__2Zjc8"};